import type { Locale } from "./types";
import type { Dict } from "./dict-shared";
import { ptDict } from "./dict.pt";

export type { Dict };

/**
 * Apenas pt-BR é estático (idioma padrão, presente em praticamente todo
 * tráfego). EN e ES saem do bundle crítico e chegam por `import()` dinâmico
 * — o Vite gera um chunk por idioma, baixado só quando o visitante está em
 * /en ou /es.
 */
export const dictionaries: Record<"pt", Dict> & Partial<Record<Locale, Dict>> = {
  pt: ptDict,
};

const cache: Partial<Record<Locale, Dict>> = { pt: ptDict };

/** Dicionário já resolvido (síncrono) quando o chunk do idioma está em cache. */
export function getCachedDict(locale: Locale): Dict | undefined {
  return cache[locale];
}

/** Carrega (e memoriza) o dicionário do idioma. */
export async function loadDict(locale: Locale): Promise<Dict> {
  const cached = cache[locale];
  if (cached) return cached;
  const dict =
    locale === "en"
      ? (await import("./dict.en")).enDict
      : locale === "es"
        ? (await import("./dict.es")).esDict
        : ptDict;
  cache[locale] = dict;
  return dict;
}
